import React, { useEffect, useState } from "react";
import RRPagosyReten from "../renderRows/RRPagosyReten";
import "./PagosYRetencionesList.css";
import DropdownSelect from "../dropdownSelect/DropdownSelect.js";
import SearchInput from "../searchInput/SearchInput.js";

const PagosYRetencionesList = ({ fchdes, fchhas, pagosList }) => {
  const [filter, setFilter] = useState("");
  const [tDocsFiltered, setTDocsFiltered] = useState(pagosList);
  //state de workspaces seleccionado (Ya definidos: Pendientes y Disponibles).
  const [activeWorkSpace, setActiveWorkSpace] = useState({
    todos: 1,
    pagos: 0,
    retenciones: 0,
  });
  //Podria crear un estado que sea Filtro y pasarle el setFiltro a DropdownSelect, este lo setearia y se usaria luego para filtrar OPs o RGs dependiendo lo que necesite el usuario.

  useEffect(() => {
    setFilter("");
    const newListFiltered = pagosList.filter(
      (p) =>
        (activeWorkSpace.todos ||
          (activeWorkSpace.pagos
            ? p.codFor.includes("OP")
            : p.codFor.includes("RG") ||
              p.codFor.includes("RI") ||
              p.codFor.includes("RS") ||
              p.codFor.includes("RB"))) &&
        new Date(p.fchMov).getTime() >= new Date(fchdes).getTime() &&
        new Date(p.fchMov).getTime() <= new Date(fchhas).getTime()
    );
    newListFiltered.sort((a, b) => b.fchMov.localeCompare(a.fchMov));
    setTDocsFiltered(newListFiltered);
  }, [activeWorkSpace, pagosList, fchdes, fchhas]);

  const handlerSearchInput = (data) => {
    setFilter(data);
  };

  const handleWorkspace = (prop) => {
    if (activeWorkSpace[prop] == 0)
      setActiveWorkSpace({ todos: 0, pagos: 0, retenciones: 0, [prop]: 1 });
  };

  return (
    <div>
      <div style={{ marginLeft: "-600px" }}>
        <SearchInput filter={filter} buscar={handlerSearchInput} />
      </div>
      <div className="pagosyretenListDiv">
        {/*<DropdownSelect options={options} setFilter={setFilter}/>*/}

        <div className="navbar-reqList">
          <div
            className={
              activeWorkSpace.todos
                ? "navbar-container-reqList-active"
                : "navbar-container-reqList"
            }
            onClick={() => handleWorkspace("todos")}
          >
            <div className="navbar-item-reqList">
              <div className="navbar-item-label-xx">TODOS</div>
            </div>
          </div>
          <div
            className={
              activeWorkSpace.pagos
                ? "navbar-container-reqList-active"
                : "navbar-container-reqList"
            }
            onClick={() => handleWorkspace("pagos")}
          >
            <div className="navbar-item-reqList">
              <div className="navbar-item-label-xx">PAGOS</div>
            </div>
          </div>
          <div
            className={
              activeWorkSpace.retenciones
                ? "navbar-container-reqList-active"
                : "navbar-container-reqList"
            }
            onClick={() => handleWorkspace("retenciones")}
          >
            <div className="navbar-item-reqList">
              <div className="navbar-item-label-xx">RETENCIONES</div>
            </div>
          </div>
        </div>
        {tDocsFiltered
          .filter((pago) =>
            filter != ""
              ? pago.codFor.toLowerCase().includes(filter.toLowerCase()) ||
                pago.nroFor
                  .toString()
                  .toLowerCase()
                  .includes(filter.toLowerCase()) ||
                `${pago.codFor.toLowerCase()} - ${pago.nroFor
                  .toString()
                  .toLowerCase()}`.includes(filter.toLowerCase())
              : 1
          )
          .map((pago) => (
            <RRPagosyReten pago={pago} filter={filter} />
          ))}
      </div>
    </div>
  );
};

export default PagosYRetencionesList;